import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import React from 'react';

interface ConfirmationDialogProps {
  body?: string;
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  title?: string;
  cancelMessage?: string;
  submitMessage?: string;
}

const ConfirmationDialog = ({
  body,
  cancelMessage = 'No',
  onClose,
  onSubmit,
  open,
  submitMessage = 'Yes',
  title = 'Are you sure?'
}: ConfirmationDialogProps) => (
  <Dialog
    onClose={onClose}
    open={open}
    aria-labelledby="dialog-title"
    aria-describedby="dialog-description"
  >
    <DialogTitle id="dialog-title">{title}</DialogTitle>
    {body ? (
      <DialogContent>
        <DialogContentText id="dialog-description">{body}</DialogContentText>
      </DialogContent>
    ) : null}
    <DialogActions>
      <Button onClick={onClose}>{cancelMessage}</Button>
      <Button onClick={onSubmit}>{submitMessage}</Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationDialog;
